<template>
  <div id="call-settings-layout">
    <div class="call-settings-layout-container">
      <div class="call-settings-navbar p-2 card">
        <router-link
          to="/settings/call-settings/after-call"
          class="navbar-item"
          :class="{
            active: currentRoute.startsWith(
              '/settings/call-settings/after-call'
            )
          }"
        >
          {{ $t('settings.callSettings.afterCall.title') }}
        </router-link>
        <router-link
          to="/settings/call-settings/default-survey"
          class="navbar-item"
          :class="{
            active: currentRoute.startsWith(
              '/settings/call-settings/default-survey'
            )
          }"
        >
          {{ $t('settings.callSettings.defaultSurvey.title') }}
        </router-link>
      </div>
      <div class="flex-fill card p-3">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CallSettingsLayout',
  computed: {
    currentRoute() {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
.call-settings-navbar {
  background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: start;
  gap: 0.5rem;
}
.call-settings-layout-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.navbar-item {
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  &.active {
    font-weight: bold;
    background-color: #f0f0f0;
  }
}
</style>
